module.exports = __webpack_public_path__ + "images/cover-light.png";